import jQuery from 'jquery';
import DiffusionSession from 'rp-diffusion-connector';
import { diffusionServiceUtils } from 'rp-prices-component';
import { EVENTS } from '../constants';

const PAGE_CONFIG_SELECTOR = '.js-diffusionTopicSettingsRace';
const EW_ELEMENT_SELECTOR = '.js-diffusionEwInfo';

export default class EachWay {
    constructor() {
        this.pageConfigElement = jQuery(PAGE_CONFIG_SELECTOR)[0];

        if (!this.pageConfigElement) {
            return;
        }

        this.raceDate = diffusionServiceUtils.getTopicRaceDate(this.pageConfigElement);
        this.courseName = diffusionServiceUtils.getTopicCourseName(this.pageConfigElement);
        this.raceTime = diffusionServiceUtils.getTopicRaceTime(this.pageConfigElement);

        if (!this.raceDate || !this.courseName || !this.raceTime) {
            return;
        }

        this.onBookieChanged = this.onBookieChanged.bind(this);
        this.onDataReceive = this.onDataReceive.bind(this);
        this.currentTopic = null;
        this.session = new DiffusionSession({
            onDataFunction: this.onDataReceive
        });

        this.bindEvents();
    }

    bindEvents() {
        jQuery(document).on(EVENTS.BOOKMAKER_CHANGED, this.onBookieChanged);
    }

    onDataReceive(WebClientMessage) {
        const {
            winOdds,
            placeWinner,
            isWinOnly
        } = diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

        this.updateEwElements(isWinOnly ? '<b>win only</b>' : [winOdds, placeWinner].join(' '));
        jQuery.event.trigger(EVENTS.INFO_TOPIC_UPDATED);
    }

    onBookieChanged(event, newBookmakerName) {
        this.updateEwElements('');

        if (this.currentTopic) {
            this.session.unsubscribe({ topic: this.currentTopic });
        }

        this.currentTopic = diffusionServiceUtils.createInfoTopic({
            raceDate: this.raceDate,
            raceTime: this.raceTime,
            courseName: this.courseName,
            bookmaker: newBookmakerName
        });

        if (this.currentTopic) {
            this.session.subscribe({ topic: this.currentTopic });
        }
    }

    updateEwElements(eachWay) {
        jQuery(EW_ELEMENT_SELECTOR)
            .toArray()
            .forEach((runnerElement) => {
                const element = runnerElement;

                element.innerHTML = eachWay;
            });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/eachWay.js